// Store
import { ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

// Access
import * as Access from './access/index';

// Dashboard
import * as Dashboard from './dashboard/index';

// State
import { BannerState } from './banner/banner.state';
import { CartState } from './cart/cart.state';
import { FilterTopState } from './dashboard/filter-top/filter-top.state';
import { CheckoutState } from './dashboard/checkout/checkout.state';
import { LayoutState } from './layout/layout.state';
import { LoginState } from './access/login/login.state';
import { MainState } from './dashboard/main/main.state';
import { RememberPassState } from './access/rememberPass/rememberPass.state';
import { ResetPassState } from './access/resetPass/resetPass.state';
import { RouterState } from './router/router.state';
import { SearchState } from './dashboard/search/search.state';
import { SignupState } from './access/signup/signup.state';
import { UserState } from './user/user.state';
import { ProductState } from './dashboard/product/product.state';

// Reducer
import { BannerReducer } from './banner/banner.reducer';
import { CartReducer } from './cart/cart.reducer';
import { FilterTopReducer } from './dashboard/filter-top/filter-top.reducer';
import { CheckoutReducer } from './dashboard/checkout/checkout.reducer';
import { LayoutReducer } from './layout/layout.reducer';
import { LoginReducer } from './access/login/login.reducer';
import { MainReducer } from './dashboard/main/main.reducer';
import { RememberPassReducer } from './access/rememberPass/rememberPass.reducer';
import { ResetPassReducer } from './access/resetPass/resetPass.reducer';
import { SearchReducer } from './dashboard/search/search.reducer';
import { SignupReducer } from './access/signup/signup.reducer';
import { UserReducer } from './user/user.reducer';
import { ProductReducer } from './dashboard/product/product.reducer';

// Effects
import { CartEffects } from './cart/cart.effects';
import { RouterEffects } from './router/router.effects';
import { UserEffects } from './user/user.effects';
import { WebtrekkEffects } from './webtrekk/webtrekk.effects';
import { BannerEffects } from './banner/banner.effects';

export const effects = [
    RouterEffects,
    ...Dashboard.dashboardEffects,
    ...Access.accessEffects,
    UserEffects,
    BannerEffects,
    CartEffects,
    WebtrekkEffects,
];

export interface AppState {
    banner: BannerState;
    cart: CartState;
    layout: LayoutState;
    login: LoginState;
    main: MainState;
    rememberPass: RememberPassState;
    resetPass: ResetPassState;
    router: RouterReducerState<RouterState>;
    search: SearchState;
    signup: SignupState;
    user: UserState;
    filterTop: FilterTopState;
    checkout: CheckoutState;
    alternativeProducts: ProductState;
    rates: ProductState;
}

export const reducers: ActionReducerMap<AppState> = {
    banner: BannerReducer,
    cart: CartReducer,
    layout: LayoutReducer,
    login: LoginReducer,
    main: MainReducer,
    rememberPass: RememberPassReducer,
    resetPass: ResetPassReducer,
    router: routerReducer,
    search: SearchReducer,
    signup: SignupReducer,
    user: UserReducer,
    filterTop: FilterTopReducer,
    checkout: CheckoutReducer,
    alternativeProducts: ProductReducer,
    rates: ProductReducer,
};
